export enum FooterEventActionEnum {
    element,
    socialIcon,
    appIcon,
    link,
}